import {Controller} from "@hotwired/stimulus"

// Inline shipment ETA / invoice number editing on the purchase order page.
// Each field belongs to a tiny per-shipment form (form="shipment-<id>-eta-form"),
// so saving submits only that shipment.
//
// Replaces an inline :javascript block bound in `$(document).ready`, which rebound
// on every Turbolinks visit and fired the confirm dialog once per binding.
export default class extends Controller {
    // Changing a shipment ETA is worth confirming: it is the date the vendor was
    // told. Declining restores the previous value.
    confirmEta(event) {
        const field = event.currentTarget
        const previous = field.dataset.originalValue || ""
        const next = field.value

        if (previous === next) return

        const change = previous ? `from ${previous} to ${next}` : `to ${next}`

        if (window.confirm(`Are you sure you want to change the shipment ETA ${change}?`)) {
            this.submitFor(field)
        } else {
            field.value = previous
        }
    }

    saveInvoice(event) {
        const field = event.currentTarget
        if ((field.dataset.originalValue || "") === field.value) return

        this.submitFor(field)
    }

    saveInvoiceDate(event) {
        const field = event.currentTarget
        if ((field.dataset.originalValue || "") === field.value) return

        this.submitFor(field)
    }

    submitFor(field) {
        const form = document.getElementById(`shipment-${field.dataset.shipmentId}-eta-form`)
        if (form) form.requestSubmit()
    }
}
